<script lang="ts">
  interface Props {
    progress: number
  }
  let props = $props()
  let { progress }: Props = props
</script>

<div class="relative w-16 h-16 rounded-full bg-black/70">
  <svg class="w-full h-full" viewBox="0 0 100 100">
    <!-- Background circle -->
    <circle
      class="text-gray-200 stroke-current"
      stroke-width="8"
      cx="50"
      cy="50"
      r="40"
      fill="transparent"
    ></circle>
    <!-- Progress circle -->
    <circle
      class="text-green-500 progress-ring__circle stroke-current"
      stroke-width="8"
      stroke-linecap="round"
      cx="50"
      cy="50"
      r="40"
      fill="transparent"
      stroke-dasharray="251.2"
      stroke-dashoffset="calc(251.2px - (251.2px * {progress}) / 100)"
    ></circle>

    <!-- Center text -->
    <text
      x="50"
      y="50"
      font-family="Verdana"
      stroke="white"
      fill="white"
      font-size="20"
      text-anchor="middle"
      alignment-baseline="middle">{progress}%</text
    >
  </svg>
</div>

<style>
  .progress-ring__circle {
    transition: stroke-dashoffset 0.35s;
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
  }
</style>
